__turbopack_context__.v({
  "attribute": "CandidateCardProfessional-module__ZBXbEW__attribute",
  "attributes": "CandidateCardProfessional-module__ZBXbEW__attributes",
  "avatarBlurred": "CandidateCardProfessional-module__ZBXbEW__avatarBlurred",
  "avatarFallback": "CandidateCardProfessional-module__ZBXbEW__avatarFallback",
  "avatarImage": "CandidateCardProfessional-module__ZBXbEW__avatarImage",
  "avatarWrapper": "CandidateCardProfessional-module__ZBXbEW__avatarWrapper",
  "card": "CandidateCardProfessional-module__ZBXbEW__card",
  "emoji": "CandidateCardProfessional-module__ZBXbEW__emoji",
  "headings": "CandidateCardProfessional-module__ZBXbEW__headings",
  "hiddenAttribute": "CandidateCardProfessional-module__ZBXbEW__hiddenAttribute",
  "highlights": "CandidateCardProfessional-module__ZBXbEW__highlights",
  "moreAttributes": "CandidateCardProfessional-module__ZBXbEW__moreAttributes",
  "name": "CandidateCardProfessional-module__ZBXbEW__name",
  "recruiterLogo": "CandidateCardProfessional-module__ZBXbEW__recruiterLogo",
  "root": "CandidateCardProfessional-module__ZBXbEW__root",
  "skillLogo": "CandidateCardProfessional-module__ZBXbEW__skillLogo",
  "skillName": "CandidateCardProfessional-module__ZBXbEW__skillName",
  "title": "CandidateCardProfessional-module__ZBXbEW__title",
  "top": "CandidateCardProfessional-module__ZBXbEW__top",
});
